<template>
	<div class="containner flex justify-center mt-40">
		<div>上一页</div>
		<div 
		v-for="count of totalpage" 
		:key="count" 
		:class="{'active': selected_page==count}"
		@click="page_click(count)">{{count}}</div>
		
		<div>下一页</div>
	</div>
</template>

<script>
	export default {
		props:[
			'totalpage',
			
		],
		data () {	
			return {
				selected_page: 1
			}
		},
		methods: {
			page_click (count) {
				this.$emit('parentClick',count)
				this.selected_page = count
			}
		}
	}
</script>

<style scoped="scoped">
	.containner div {
		border: 1px solid #8793ff;
		padding: 0 15px 0 15px;
		height: 35px;
		line-height: 35px;
		margin: 0 5px 0 0;	
	}
	.active {
		color: #ff0000;
	}
</style>
